module.exports = __webpack_public_path__ + "img/mitzy-2022.a530e6bc.jpg";